import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskHistoryOverviewStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
        },
        bold: {
            fontWeight: theme.typography.fontWeightBold,
        },
        why: {
            maxWidth: 360,
            whiteSpace: "normal",
            color: theme.palette.text.secondary,
        },
    });
};
